import React, { useLayoutEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Col, Row } from 'reactstrap';
import { BUS_MAINTENANCE_STAY_PATH } from '../../../../config/paths';
import { breadcrumbsPropTypes } from '../../../common/resource/proptypes/CommonPropTypes';
import {
  clearBussesMaintenanceStay,
  getBusMaintenanceStayDemand,
  getBussesMaintenanceStay,
  putBulkUpdateMaintenanceStay,
} from '../../../../actions/mechanical-maintenance/BusMaintenanceStay';
import Content from '../../../layout/Content';
import BusMaintenanceStayColumnToolbar from './BusMaintenanceStayColumnToolbar';
import BusMaintenanceStaySearchForm from './BusMaintenanceStaySearchForm';
import { tzNormalizeDate } from '../../../../utils/date';
import { INT_DATE_FORMAT, TIMESTAMP_FORMAT } from '../../../../config/locale';
import BusMaintenanceStayTable from './BusMaintenanceStayTable';
import BusMaintenanceStayDemandTable from './BusMaintenanceStayDemandTable';

export const BussesMaintenanceStay = ({
  breadcrumbs,
  loading,
  dispatchGetBussesMaintenanceStay,
  dispatchClearBussesMaintenanceStay,
  dispatchGetBusMaintenanceStayDemand,
  dispatchPutBulkUpdateMaintenanceStay
}) => {

  useLayoutEffect(() => {
    dispatchGetBusMaintenanceStayDemand({
      fromDateString: tzNormalizeDate({ format: INT_DATE_FORMAT }),
      toDateString: tzNormalizeDate({ format: INT_DATE_FORMAT }),
    });
    return () => {
      dispatchClearBussesMaintenanceStay();
    };
  }, []);

  const toolBar = <BusMaintenanceStayColumnToolbar />;

  const onHandleSubmit = (formValues) => {
    const fromDateString = tzNormalizeDate({
      date: formValues.fromDateString,
      format: INT_DATE_FORMAT,
    });
    const toDateString = tzNormalizeDate({
      date: formValues.toDateString,
      format: INT_DATE_FORMAT,
    });
    const cityId = formValues.city ? formValues.city.value : null;

    const newFormValues = {
      fromDateString,
      toDateString,
      cityId
    };

    dispatchGetBusMaintenanceStayDemand(newFormValues);
    dispatchGetBussesMaintenanceStay(newFormValues);
  };

  const onHandleBulkSave = async (updatedData, deletedData) => {

    const updates = updatedData.map(item => ({
      id: item.id,
      registeredBusId: (item.registeredBusId && item.registeredBusId.value) || item.registeredBusId,
      originCityId: (item.originCityId && item.originCityId.value) || item.originCityId,
      maintenanceStayStatus: (item.maintenanceStayStatus && item.maintenanceStayStatus.value) || item.maintenanceStayStatus,
      observation: item.observation,
      estimatedArrivalDate: item.estimatedArrivalDate ? tzNormalizeDate({ date: item.estimatedArrivalDate, format: TIMESTAMP_FORMAT }) : null,
      estimatedCompletionDate: item.estimatedCompletionDate ? tzNormalizeDate({ date: item.estimatedCompletionDate, format: TIMESTAMP_FORMAT }) : null,
      noArrivalTime: item.noArrivalTime,
    }));

    const deletes = deletedData.map(item => item.id);

    const payload = {
      updateBusMaintenanceStayList: updates,
      deleteBusMaintenanceStayIdList: deletes,
    };

    dispatchPutBulkUpdateMaintenanceStay(payload);

  };


  const content = (
    <>
      <Row>
        <Col xs={12} md={4} className="order-md-1 mb-3" >
          <BusMaintenanceStayDemandTable />
        </Col>
        <Col xs={12} md={8} className="order-md-2">
          <BusMaintenanceStaySearchForm
            onSubmit={onHandleSubmit}
            initialValues={{
              fromDateString: tzNormalizeDate(),
              toDateString: tzNormalizeDate(),
            }}
            loading={loading}
          />
        </Col>
      </Row>
      <div className='mt-5'>
        <BusMaintenanceStayTable
          onHandleBulkSave={onHandleBulkSave}
        />
      </div>
    </>
  );

  return (
    <Content
      title="Estancias de Mantenimiento por Bus"
      breadcrumbs={breadcrumbs}
      toolbar={toolBar}
      content={content}
    />
  );
};

const mapDispatchToProps = {
  dispatchGetBussesMaintenanceStay: getBussesMaintenanceStay,
  dispatchClearBussesMaintenanceStay: clearBussesMaintenanceStay,
  dispatchGetBusMaintenanceStayDemand: getBusMaintenanceStayDemand,
  dispatchPutBulkUpdateMaintenanceStay: putBulkUpdateMaintenanceStay,
};

const mapStateToProps = ({ MechanicalMaintenanceUnit }) => ({
  breadcrumbs: [
    ...MechanicalMaintenanceUnit.UnitHome.get('breadcrumbs'),
    {
      text: 'Estancias de Mantenimiento por Bus',
      href: BUS_MAINTENANCE_STAY_PATH,
    },
  ],
  bussesMaintenanceStay: MechanicalMaintenanceUnit.BusMaintenanceStay.getIn([
    'all',
    'content',
  ]),
  loading: MechanicalMaintenanceUnit.BusMaintenanceStay.getIn([
    'all',
    'loading',
  ]),

});

BussesMaintenanceStay.propTypes = {
  breadcrumbs: breadcrumbsPropTypes.isRequired,
  loading: PropTypes.bool,
  dispatchGetBussesMaintenanceStay: PropTypes.func.isRequired,
  dispatchGetBusMaintenanceStayDemand: PropTypes.func.isRequired,
  dispatchClearBussesMaintenanceStay: PropTypes.func.isRequired,
  dispatchPutBulkUpdateMaintenanceStay: PropTypes.func.isRequired,
};

BussesMaintenanceStay.defaultProps = {
  loading: false,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(BussesMaintenanceStay);